import "./swiper-bundle.esm.js";
import { t as ResponsiveSwiper } from "./ResponsiveSwiper.js";
//#region frontend/entrypoints/sf-index-voice.js
document.addEventListener("DOMContentLoaded", () => {
	const voiceContainer = document.querySelector(".swiper.p-index-voice__inner");
	if (voiceContainer) new ResponsiveSwiper(voiceContainer, "(max-width: 768px)", {
		loop: false,
		speed: 500,
		slidesPerView: 1.3,
		spaceBetween: 40,
		pagination: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
			addIcons: false
		},
		breakpoints: { 481: { slidesPerView: 2.2 } }
	});
});
//#endregion
